export interface AnalyticsAPI {
  test?(): boolean;
  identify(userId: string, userProperties: any, isLazy?: boolean): void;
  track(eventName: string, eventProperties: any, isLazy?: boolean): void;
  page(category: string, name: string, properties: any): void;
  alias(userId: string, previousId: string): void;
  group(groupId: string, traits: any): void;
}

export interface TrackCall {
  eventName: string;
  eventProperties: any;
}

export interface IdentifyCall {
  userId: string;
  userProperties: any;
}

export interface RunPendingCallsConfig {
  pendingCalls: any[];
  type: "track" | "identify";
}

export enum CallType {
  Track = "track",
  Identify = "identify",
  Page = "page"
}



// WEBPACK FOOTER //
// ./src/analytics.model.ts